import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const WarningContainer = styled(Box)(
  ({ theme }) => `

  display: flex;
  padding: 16px 20px;
  background: rgba(255, 213, 152, 0.3);
  border-radius: 4px;
  gap: 18px;
  margin-top: 16px;
  margin-bottom: 8px;

  svg {
    color: #FFB547;
    margin-top: 4px;
  }
`,
);
